import _ from 'lodash'
import { SectionLink } from './Page'
import { Section } from './Section'

class ChamberService {
    constructor({ id, service_slug, services, description, categoryId, links, link, sections }) {
        this.sid = id
        this.slug = service_slug
        this.name = services
        this.description = description
        this.categoryId = categoryId
        this.links = links
        // this.linkToPortal = link
        this.sectionList = sections
        this.link = link || `/komorske-usluge/${this.slug}`
    }

    get id() {
        return this.slug || this.sid
    }

    get serviceDescription() {
        const temporalDIV = document.createElement('div')
        temporalDIV.innerHTML = this.description

        return temporalDIV.textContent || ''
    }

    get htmlDescription() {
        return {
            __html: this.description
        }
    }

    get hasHtmlDescription() {
        return !_.isEmpty(this.description)
    }

    get sectionLinks() {
        return this.links.map(link => new SectionLink(link))
    }

    get sections() {
        return this.sectionList.map(section => new Section(section))
    }
}

export { ChamberService }
